/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CoffeeOutlined,
  EyeOutlined,
  LoadingOutlined,
  ProjectOutlined,
  ToolOutlined,
} from '@ant-design/icons'
import {
  Alert,
  Button,
  Card,
  Popconfirm,
  Space,
  Tooltip,
  Typography,
} from 'antd'
import React from 'react'
import { useTask } from '~/hooks/Tasks/useTask'
import ExecutionTask from './ExecutionTask'
import { translate } from '~/utils/locale'
import { format, formatDistanceStrict } from 'date-fns'

import { ptBR } from 'date-fns/locale'

const StatusTaskDetails: React.FC = () => {
  const { task, isLoading, refetch, updateCanceledTask } = useTask()
  const { Title } = Typography

  if (isLoading || !task) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  const checkOutStatus: any = task.status.find((t) => t.type === 'checkout')
  const checkInStatus: any = task.status.find((t) => t.type === 'check-in')

  async function CanceledTask() {
    const data = {
      status: {
        collaborator_id: task?.responsible.id,
        location: {
          x: task?.address.location.x,
          y: task?.address.location.y,
        },
      },
    }

    try {
      await updateCanceledTask(data)
      refetch()
    } catch (err: any) {
      console.log(err)
    }
  }

  const checkoutTask = format(
    new Date(checkOutStatus ? checkInStatus.created_at : new Date()),
    `dd/MM/yyyy '${translate('TasksTabsDetails.dateString')}' HH:mm'h'`,
  )

  const checkInDate = checkInStatus
    ? new Date(checkInStatus.created_at)
    : new Date()
  const checkOutDate = checkOutStatus
    ? new Date(checkOutStatus.created_at)
    : new Date()

  const finishedTaskDate = formatDistanceStrict(checkInDate, checkOutDate, {
    locale: ptBR,
  })

  return (
    <Card
      bordered={false}
      title={
        <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
          Status
        </Title>
      }
      extra={
        <Space size="small">
          {task?.responsible &&
            task.current_status !== 'canceled' &&
            task.current_status !== 'finished' && <ExecutionTask />}
          {task?.current_status !== 'canceled' &&
          task.current_status !== 'finished' ? (
            <Tooltip title="Cancelar Tarefa">
              <Popconfirm
                onConfirm={CanceledTask}
                title="Deseja mesmo cancelar a tarefa?"
              >
                <Button icon={<CloseOutlined style={{ fontSize: 12 }} />} />
              </Popconfirm>
            </Tooltip>
          ) : (
            ''
          )}
        </Space>
      }
      style={{
        display: 'inline-block',
        width: '100%',
        marginTop: 15,
      }}
    >
      {task?.current_status === 'received' ? (
        <Alert
          message={translate('TasksTabsDetails.statusReceived')}
          icon={<ProjectOutlined />}
          style={{
            color: '#003a8c',
            backgroundColor: '#188fff2f',
            borderColor: '#096dd9',
          }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'viewed' ? (
        <Alert
          message={translate('TasksTabsDetails.statusViewed')}
          icon={<EyeOutlined />}
          style={{ color: '#2db7f5' }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'working' ? (
        <Alert
          message={translate('TasksTabsDetails.statusWorking')}
          icon={<ToolOutlined style={{ color: '#088b55' }} />}
          style={{
            color: '#088b55',
            backgroundColor: '#088b5421',
            borderColor: '#088b55',
          }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'en-route' ? (
        <Alert
          message={translate('TasksTabsDetails.statusEnRoute')}
          icon={<CarOutlined style={{ color: '#521e9b' }} />}
          style={{
            color: '#521e9b',
            backgroundColor: '#722ed130',
            borderColor: '#521e9b',
          }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'break' ? (
        <Alert
          message={translate('TasksTabsDetails.statusBreak')}
          icon={<CoffeeOutlined style={{ color: '#fa8c16' }} />}
          style={{
            color: '#fa8c16',
            backgroundColor: '#faad1422',
            borderColor: '#fa8c16',
          }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'canceled' ? (
        <Alert
          message={translate('TasksTabsDetails.statusCanceled')}
          icon={<CloseCircleOutlined style={{ color: '#ce151e' }} />}
          style={{
            color: '#ce151e',
            backgroundColor: '#ce151e28',
            borderColor: '#ce151e',
          }}
          showIcon
        />
      ) : (
        ''
      )}

      {task?.current_status === 'finished' ? (
        <>
          <Alert
            message={`A tarefa foi finalizada no período de ${finishedTaskDate}`}
            type="info"
            showIcon
          />
          <Alert
            message={`${translate(
              'TasksTabsDetails.statusFinished',
            )} ás ${checkoutTask}`}
            icon={<CheckCircleOutlined style={{ color: '#0f4b83' }} />}
            style={{
              color: '#0f4b83',
              backgroundColor: '#0f4b8318',
              borderColor: '#0f4b83',
              marginTop: 10,
            }}
            showIcon
          />
        </>
      ) : (
        ''
      )}
    </Card>
  )
}

export default StatusTaskDetails
